<!-- Floating Chatbot Launcher -->
<button *ngIf="isVisible" class="chatbot-launcher-btn" (click)="toggleChat()" aria-label="Toggle chatbot assistance">
  <i class="material-symbols-outlined">{{ isOpen ? 'close' : 'chat' }}</i>
</button>

<!-- Chatbot Drawer Window -->
<div class="chatbot-window" *ngIf="isVisible && isOpen">
  <!-- Header -->
  <div class="chatbot-header">
    <div class="chatbot-header-title">
      <i class="material-symbols-outlined chatbot-icon">support_agent</i>
      <span>{{ t[language].title }}</span>
    </div>
    
    <!-- Live Agent Header Badge -->
    <div *ngIf="isLiveAgentMode" class="live-agent-status-badge">
      <span class="live-pulse-dot"></span>
      <span>{{ liveAgentStatus === 'connected' ? assignedAgentName : 'Connecting...' }}</span>
      <button class="end-chat-sm-btn" (click)="endLiveChat()" title="End Chat">
        <i class="material-symbols-outlined">call_end</i>
      </button>
    </div>
    
    <!-- Language Switcher -->
    <div class="lang-switch-container" *ngIf="!isLiveAgentMode">
      <button [class.active]="language === 'en'" (click)="changeLanguage('en')">EN</button>
      <button [class.active]="language === 'or'" (click)="changeLanguage('or')">ଓଡ଼ି</button>
    </div>
  </div>

  <!-- Messages Area -->
  <div class="chat-messages">
    <div *ngFor="let msg of messages" [ngClass]="['message-bubble', msg.sender === 'user' ? 'message-user' : 'message-bot', msg.checklist ? 'has-checklist' : '', msg.credentials ? 'has-credentials' : '']">
      
      <!-- Normal Text Messages -->
      <p *ngIf="msg.text" class="message-text">{{ msg.text }}</p>

      <!-- Checklist Custom Component -->
      <div *ngIf="msg.checklist" class="chatbot-checklist-container">
        <div *ngFor="let item of msg.checklist" class="checklist-card">
          <div class="checklist-header">
            <strong>{{ item.name }} ({{ item.type }})</strong>
            <span class="badge" [ngClass]="(item.status || '').toLowerCase()">{{ item.status }}</span>
          </div>
          
          <div class="checklist-items">
            <!-- Photo Checklist -->
            <div class="checklist-item">
              <i class="material-symbols-outlined check-icon" [ngClass]="item.hasPhoto ? 'valid' : 'invalid'">
                {{ item.hasPhoto ? 'check_circle' : 'cancel' }}
              </i>
              <span>{{ t[language].checklistPhoto }}: <strong>{{ item.hasPhoto ? t[language].yes : t[language].no }}</strong></span>
            </div>

            <!-- Bank Passbook Checklist -->
            <div class="checklist-item">
              <i class="material-symbols-outlined check-icon" [ngClass]="item.hasBankPassbook ? 'valid' : 'invalid'">
                {{ item.hasBankPassbook ? 'check_circle' : 'cancel' }}
              </i>
              <span>{{ t[language].checklistPassbook }}: <strong>{{ item.hasBankPassbook ? t[language].yes : t[language].no }}</strong></span>
            </div>

            <!-- Members Checklist (only Troupe) -->
            <div class="checklist-item" *ngIf="item.type === 'TROUPE'">
              <i class="material-symbols-outlined check-icon" [ngClass]="item.hasMembers ? 'valid' : 'invalid'">
                {{ item.hasMembers ? 'check_circle' : 'cancel' }}
              </i>
              <span>{{ t[language].checklistMembers }}: <strong>{{ item.hasMembers ? t[language].yes : t[language].no }}</strong></span>
            </div>
          </div>
        </div>
      </div>

      <!-- Credentials Display Component -->
      <div *ngIf="msg.credentials" class="chatbot-credentials-card">
        <h4>{{ t[language].credentialsTitle }}</h4>
        <div class="credential-row">
          <span>{{ t[language].username }}:</span>
          <strong>{{ msg.credentials.username }}</strong>
        </div>
        <small class="text-muted">{{ t[language].passwordNote }}</small>
      </div>

      <!-- Schedule Timeline Display Card Component -->
      <div *ngIf="msg.scheduleCard" class="chatbot-schedule-card">
        <div class="schedule-card-header">
          <i class="material-symbols-outlined header-icon">calendar_month</i>
          <strong>{{ msg.scheduleCard.title }}</strong>
        </div>
        <div class="schedule-card-body">
          <div *ngFor="let item of msg.scheduleCard.items" class="schedule-item-row" [class.is-highlight]="item.highlight">
            <div class="item-left">
              <i class="material-symbols-outlined item-icon">{{ item.icon }}</i>
              <span class="item-label">{{ item.label }}</span>
            </div>
            <span class="schedule-date-badge" [class.badge-glow]="item.highlight">
              {{ item.date }}
            </span>
          </div>
        </div>
      </div>

      <!-- Quick Option Action Buttons -->
      <div *ngIf="msg.options && msg.options.length > 0" class="message-options">
        <button *ngFor="let opt of msg.options" class="option-btn" (click)="handleOptionClick(opt.action)">
          {{ opt.label }}
        </button>
      </div>

    </div>

    <!-- Spinner Loading State -->
    <div class="bot-loading" *ngIf="loading">
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
    </div>
  </div>

  <!-- Input Footer Form -->
  <div class="chat-footer" *ngIf="currentFlow === 'mobile_reset' || isLiveAgentMode">
    <input type="text" 
           [(ngModel)]="userInput" 
           [placeholder]="t[language].placeholder" 
           (keyup.enter)="handleSend()" 
           maxlength="200" />
    <button (click)="handleSend()" aria-label="Send message">
      <i class="material-symbols-outlined">send</i>
    </button>
    <button *ngIf="isLiveAgentMode" class="end-live-btn" (click)="endLiveChat()" title="End Live Chat">
      <i class="material-symbols-outlined">call_end</i>
    </button>
  </div>
</div>
